module.exports = __webpack_public_path__ + "static/img/logo.feb57882.png";